function InitiateLogRocket(environment, newSession, id)
{
    try{
        var userId = sessionStorage.getItem('civilId');
        if((userId || id) && environment.isLogRocketEnabled)
        {
            LogRocket.init(environment.logRocketId, {
                dom: {
                    //inputSanitizer: true,
                    privateAttributeBlocklist: ['sensitive-data']
                }
            });
            
            if (typeof LogRocket === 'undefined')
                console.log('Could not initiate LogRocket');
            else{
                if(newSession)
                    LogRocket.startNewSession();
                userId = userId? encrypt(userId) : id; 
                LogRocket.identify(userId);
                console.log('LogRocket new session identity : ' + userId);
            }
        }
    }
    catch(error){
        console.log('LogRocket Initialization failed : ' + error);
    }
}

const shift = 3;
function encrypt(id) {
    return id.split('')
    .map(char => String.fromCharCode( 65 + ( parseInt(char) + shift) % 10 ))
    .join('');
}

// function decrypt(id){
//     userId.split('').map(char => {
//         let originalDigit = (char.charCodeAt(0) - 65 - shift + 10) % 10; 
//         return originalDigit.toString();
//     }).join('');
// }